import PropTypes from "prop-types"
import { columnsPropTypes, rowPropTypes } from "components/ui/Table/tablePropsTypes"
import DraggableTableRow from "./DraggableTableRow"
import BaseTableRow from "./BaseTableRow"

const TableRow = ({
  columns,
  row,
  draggableType,
  index,
  isDraggable,
  className = "",
  style = {},
  onRowClick,
  isSelectable,
  onSelectChange,
  selectableField,
  isDeletable,
  onDeleteClick
}) => {
  const tableRowProps = {
    columns,
    row,
    index,
    className,
    style,
    onRowClick,
    isSelectable,
    onSelectChange,
    selectableField,
    isDeletable,
    onDeleteClick
  }

  return isDraggable ? (
    <DraggableTableRow {...tableRowProps} draggableType={draggableType} />
  ) : (
    <BaseTableRow {...tableRowProps} />
  )
}

TableRow.propTypes = {
  columns: columnsPropTypes.isRequired,
  row: rowPropTypes.isRequired,
  draggableType: PropTypes.string,
  isDraggable: PropTypes.bool,
  index: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  onRowClick: PropTypes.func,
  isSelectable: PropTypes.bool,
  onSelectChange: PropTypes.func,
  selectableField: PropTypes.string,
  isDeletable: PropTypes.bool,
  onDeleteClick: PropTypes.func
}

export default TableRow
